import React from 'react';
import { cn } from 'lib/utils';

/**
 * Plain buttons in a light track; the chosen one is a white tile.
 *
 * Buttons here use border-[1px], not `border`: Bootstrap's `.border` utility
 * (!important) would force its grey border over every colour set below.
 */
const Segmented = ({ options, value, onChange, disabled, label }) => (
  <div role='radiogroup' aria-label={label} className='inline-flex rounded-lg bg-muted p-1'>
    {options.map((option) => {
      const active = option.value === value;
      return (
        <button
          key={option.value}
          type='button'
          role='radio'
          aria-checked={active}
          disabled={disabled}
          onClick={() => onChange(option)}
          className={cn(
            'appearance-none rounded-md border-[1px] border-solid px-3 py-1.5 text-sm transition-colors disabled:opacity-50',
            active
              ? 'border-border bg-white font-medium text-foreground'
              : 'border-transparent bg-transparent text-muted-foreground hover:text-foreground',
          )}
        >
          {option.label}
        </button>
      );
    })}
  </div>
);

export default Segmented;
